import focusElement from '@/mixins/focusElement'

export const focusOrder = {
    data: () => ({
        activeElement: null,
    }),
    methods: {
        restorePageFocus,

        storeActiveEl() {
            this.activeElement = document.activeElement
        },

        restoreActiveEl() {
            this.activeElement && this.activeElement.focus()
        }
    },
}

export const focusOrderWatcher = {
    data: () => ({
        watchable: false,
    }),
    watch: {
        '$route.path' () {
            this.watchable && restorePageFocus()
        },
    },
    activated() {
        this.watchable = true
    },
    deactivated() {
        this.watchable = false
    },
}

function restorePageFocus( className, delayMs = 1000 ) {
    className = className || '.title'
    return setTimeout(focusElement.bind({}, className), delayMs)
}